import React, { useState, useEffect } from 'react'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import NProgress from 'nprogress'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import Budget from '../../../widgets/budget/Budget'
import ProjectBasicInfo from '../../../widgets/projectBasicInfo/ProjectBasicInfo'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { getSchema } from '../../../redux/actions/paymentCheckForDirector'

// Not use for now
export default function PaymentCheckForReviewer() {
  const [isLoading, setIsLoading] = useState(false)
  const [schema, setSchema] = useState()

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    NProgress.start()
    try {
      const _schema = await getSchema()
      setSchema(_schema)
    } catch (e) {}
    NProgress.done()
    setIsLoading(false)
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} />

      <ProjectBasicInfo schema={schema.projectBasicInfo} />
      <br />
      <Budget
        schema={schema.budget}
        isEditable={false}
        onClick={() => {}}
        isCollapseAllTableRow={true}
      />
      <br />
    </SidebarProposal>
  )
}
